export const INITIAL_TIME_RANGE_ONE_DAY = '1 00:00:00'
